/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$spacer-height-default: 48px !default;
$spacer-height-desktop: 32px !default;
$spacer-height-tablet: 32px !default;
$spacer-height-phone: 24px !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
}

.#{$prefix}spacer {
  display: block;
  height: $spacer-height-default;

  @include for-size(desktop-l-or-larger) {
    &.#{$prefix}spacer-hidden-desktop-large {
      display: none;
    }
  }

  @include for-size(desktop) {
    height: $spacer-height-desktop;

    &.#{$prefix}spacer-hidden-desktop {
      display: none;
    }
  }

  @include for-size(tablet) {
    height: $spacer-height-tablet;

    &.#{$prefix}spacer-hidden-tablet {
      display: none;
    }
  }

  @include for-size(phone) {
    height: $spacer-height-phone;

    &.#{$prefix}spacer-hidden-phone {
      display: none;
    }
  }
}
